const headRowsCompany = {
  name: 'Empresa',
  email: 'E-mail',
  accountable: 'Responsável',
};

export default headRowsCompany;
